import { post } from "@/utils/utils";
function SectionToChinese(section) {
  let chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
  let strIns = "",
    chnStr = "";
  let unitPos = 0;
  let zero = true;
  while (section > 0) {
    let v = section % 10;
    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = chnNumChar[v] + chnStr;
      }
    } else {
      zero = false;
      strIns = chnNumChar[v];
      strIns += chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
    }
    unitPos++;
    section = Math.floor(section / 10);
  }
  return chnStr;
}
const distributionCenter = {
  state: {
    relInfoList: {},
    autotagList: {},
    detailRules: {},
    wxShopList: {},
    distributionBillList: {},
    detailsBill: {
      shareOrderRelDetailsInfos: {
        records: []
      }
    },
    detailsWithdraw: {
      getcashOrders: {
        records: []
      }
    },
    extractManageList: {},
    extractTotal: {},
    shareCenterPrice: {},
    detailsTimeline: {},
    orderNewList: {},
    commissionPriceList: {},
    allExtractManageList: {},
    shareAgentList: {}
  },
  mutations: {
    // editDistributionGoods(state, data) {
    //   state.relInfoList.records.forEach((v, i) => {
    //     if (i == data) {
    //       v.disabled = false;
    //     }
    //   });
    // },
    QUERY_RELINFO_LIST(state, data) {
      state.relInfoList = data.result;
      state.relInfoList.records.forEach(v => {
        v.disabled = true;
        v.commissionValue = (v.commissionValue * 100).toFixed(2);
      });
    },
    ADD_RELINFO(state, data) {
      state.addrelInfoL = data.result;
    },
    EDIT_RELINFO(state, data) {
      state.editrelInfoL = data.result;
    },
    DEL_RELINFO(state, data) {
      state.delrelInfoL = data.result;
    },
    AUTOTAGLIST(state, data) {
      state.autotagList = data.result;
    },
    ADD_RULE(state, data) {
      state.addRules = data.result;
    },
    DETAILS_RULE(state, data) {
      state.detailRules = data.result;
    },
    QUERY_WXSHOP_LIST(state, data) {
      state.wxShopList = data.result;
    },
    EDIT_BATCH_RELINFO(state, data) {
      state.batchRelinfo = data.result;
    },
    DISTRIBUTION_BILL_LIST(state, data) {
      state.distributionBillList = data.result;
    },
    DETAILS_BILL(state, data) {
      state.detailsBill = data.result;
    },
    DETAILS_WITHDRAW(state, data) {
      state.detailsWithdraw = data.result;
    },
    EXTRACT_LIST(state, data) {
      state.extractManageList = data.result;
    },
    EXTRACT_ALL_LIST(state, data) {
      state.allExtractManageList = data.result;
    },
    QUERY_TOTAL(state, data) {
      state.extractTotal = data.result;
    },
    SHARE_GETCASH_ORDER(state, data) {
      state.shareGetcashOrder = data.result;
    },
    PAY_BATCH(state, data) {
      state.payBatch = data.result;
    },
    SHARE_CENTER_PRICE(state, data) {
      state.shareCenterPrice = data.result;
    },
    SAVE_TIME_LINE(state, data) {
      state.saveTimeline = data.result;
    },
    DETAILS_TIME_LINE(state, data) {
      state.detailsTimeline = data.result;
    },
    QUERY_ORDER_NEW_LIST(state, data) {
      state.orderNewList = data.result;
    },
    QUERY_COMMISSION_PRICE_LIST(state, data) {
      state.commissionPriceList = data.result;
    },
    QUERY_ALL_RELINFO_LIST() {},
    ADD_AGENT_TITLE() {},
    QUERY_AGENT_TITLE_LIST() {},
    REMOVE_AGENT_TITLE() {},
    ADD_SHARE_AGENT() {},
    QUERY_SHARE_AGENT_LIST() {},
    ADD_SHARE_RULE_CONFIG_NEW() {},
    SYS_CONFIG_QUERY() {},
    DETAILS_SHARE_RULE_CONFIG_NEW() {},
    EDIT_SHARE_AGENT() {},
    QUERY_PARENT_SHARE_AGENT_LIST() {},
    ADD_SHARE_AGENT_EDUC() {},
    QUERY_SHARE_AGENT_EDUC_LIST() {},
    EDIT_SHARE_AGENT_EDUC() {},
    QUERY_SHARE_AGENT_FLOW_LIST() {},
    QUERY_SHARE_AGENT_FLOW_ALL_LIST() {},
    QUERY_DETAILS_SHARE_AGENT_FLOW() {},
    QUERY_SHARE_GOODS_SN() {},
    SHARE_SKU_DATE_RANGE_FLOW_NEW() {},
    ADD_FIXED_SHARE_SKU() {},
    QUERY_SHARE_SKU_DATE_RANGE_FLOW_NEW_LIST() {},
    QUERY_ALL_SHARE_SKU_DATE_RANGE_FLOW_NEW_LIST() {},
    EDIT_SHARE_SKU_DATE_RANGE_FLOW_NEW() {},
    SYS_TEXT_ADDORUP() {},
    QUERY_PERSONAL_STORE_STATE() {},
    ADD_PERSONAL_STORE_STATE() {},
    EDIT_PERSONAL_STORE_STATE() {},
    QUERY_BY_INFO() {},
    QUERY_SHARE_MEMBER_ORDER_LIST() {},
    QUERY_SHARE_COMMISSION_FLOW_LIST() {},
    QUERY_ALL_SHARE_MEMBER_ORDER_LIST() {},
    BATCH_EDIT_RANGE_FLOW_NEW() {},
    EXPORT_FLOW_DETAILS_LIST() {},
    QUERY_SHARE_MEMBER_INFO_LIST() {},
    EDIT_SHARE_DUE_DATE() {},
    QUERY_PARTNER_LIST() {},
    EXPORT_SKU_DATE_RANGE() {},
    QUERY_SHARE_COMMISSION_FLOW_ALL_LIST() {},
    QUERY_STORE_EXAMINE_STATES() {},
    BATCH_APPROVAL_SHAREGETCASHORDER() {},
    SHARE_AGENT_DISTRIBUTIO_RULE_MEMBER_DUEDAY_DESC() {},
    SHARE_GROUP_LIST() {},
    ADD_SHARE_GROUP() {},
    EDIT_SHARE_GROUP() {},
    DELETE_SHARE_GROUP() {},
    SAVE_MEMBER_SHARE_GROUP() {},
  },
  actions: {
    queryRelInfoList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/list`,
        name: "QUERY_RELINFO_LIST",
        params
      });
    },
    queryAllRelInfoList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/queryShareSkuPageList`,
        name: "QUERY_ALL_RELINFO_LIST",
        params
      });
    },
    addRelInfo({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/add`,
        name: "ADD_RELINFO",
        params
      });
    },
    editRelInfo({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/edit`,
        name: "EDIT_RELINFO",
        params
      });
    },
    delRelInfo({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/deleteBatch`,
        name: "DEL_RELINFO",
        params
      });
    },
    autotagList({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=autotag_condition_mode`,
        name: "AUTOTAGLIST",
        params
      });
    },
    addRule({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareRuleConfig/add`,
        name: "ADD_RULE",
        params
      });
    },
    detailsRule({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareRuleConfig/details`,
        name: "DETAILS_RULE",
        params
      });
    },
    queryWxshopList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/sku_list`,
        name: "QUERY_WXSHOP_LIST",
        params
      });
    },
    editBatchRelInfo({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/editBatch`,
        name: "EDIT_BATCH_RELINFO",
        params
      });
    },
    distributionBillList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/order_list`,
        name: "DISTRIBUTION_BILL_LIST",
        params
      });
    },
    detailsBill({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/commission_price_details`,
        name: "DETAILS_BILL",
        params
      });
    },
    detailsWithdraw({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/cash_withdrawal_details`,
        name: "DETAILS_WITHDRAW",
        params
      });
    },
    extractManageList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/query_list`,
        name: "EXTRACT_LIST",
        params
      });
    },
    extractManageAllList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/query_list`,
        name: "EXTRACT_ALL_LIST",
        params
      });
    },
    queryTotal({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/shareGetcashOrderTotal`,
        name: "QUERY_TOTAL",
        params
      });
    },
    shareGetcashOrder({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/approval_shareGetcashOrder`,
        name: "SHARE_GETCASH_ORDER",
        params
      });
    },
    payBatch({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/pay_batch`,
        name: "PAY_BATCH",
        params
      });
    },
    batchApprovalSharegetcashorder({ commit }, params) {
      return post({
        commit,
        url: `/store/shareGetcashOrder/batch_approval_shareGetcashOrder`,
        name: "BATCH_APPROVAL_SHAREGETCASHORDER",
        params
      });
    },
    shareCenterPrice({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuRelInfo/shareCenterPrice`,
        name: "SHARE_CENTER_PRICE",
        params
      });
    },
    saveTimeline({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuConfigCalendars/save`,
        name: "SAVE_TIME_LINE",
        params
      });
    },
    detailsTimeline({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/shareSkuConfigCalendars/queryByShareSkuId`,
        name: "DETAILS_TIME_LINE",
        params
      });
    },
    queryOrderNewList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/order_list_new`,
        name: "QUERY_ORDER_NEW_LIST",
        params
      });
    },
    queryDetailsCommissionPriceList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/commissionPriceList`,
        name: "QUERY_COMMISSION_PRICE_LIST",
        params
      });
    },
    addAgentTitle({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/title/add`,
        name: "ADD_AGENT_TITLE",
        params
      });
    },
    queryAgentTitleList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/title/list`,
        name: "QUERY_AGENT_TITLE_LIST",
        params
      });
    },
    removeAgentTitle({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/title/update`,
        name: "REMOVE_AGENT_TITLE",
        params
      });
    },
    addShareAgent({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/add`,
        name: "ADD_SHARE_AGENT",
        params
      });
    },
    queryAgentList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/list`,
        name: "QUERY_SHARE_AGENT_LIST",
        params
      });
    },
    queryParentAgentList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/list`,
        name: "QUERY_PARENT_SHARE_AGENT_LIST",
        params
      });
    },
    editShareAgent({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/update`,
        name: "EDIT_SHARE_AGENT",
        params
      });
    },
    addShareRuleConfigNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareRuleConfigNew/add`,
        name: "ADD_SHARE_RULE_CONFIG_NEW",
        params
      });
    },
    queryCommissionLevelLimt({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "SYS_CONFIG_QUERY",
        params
      });
    },
    detailsShareRuleConfigNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareRuleConfigNew/details`,
        name: "DETAILS_SHARE_RULE_CONFIG_NEW",
        params
      });
    },
    addShareAgentEduc({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/educ/add`,
        name: "ADD_SHARE_AGENT_EDUC",
        params
      });
    },
    queryShareAgentEducList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/educ/list`,
        name: "QUERY_SHARE_AGENT_EDUC_LIST",
        params
      });
    },
    editShareAgentEduc({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/educ/update`,
        name: "EDIT_SHARE_AGENT_EDUC",
        params
      });
    },
    queryShareAgentFlowList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/flow/list`,
        name: "QUERY_SHARE_AGENT_FLOW_LIST",
        params
      });
    },
    queryShareAgentFlowAllList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/flow/list`,
        name: "QUERY_SHARE_AGENT_FLOW_ALL_LIST",
        params
      });
    },
    queryDetailsShareAgentFlow({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/flow/detail`,
        name: "QUERY_DETAILS_SHARE_AGENT_FLOW",
        params
      });
    },
    queryShareGoodsSn({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/queryByGoodsSn`,
        name: "QUERY_SHARE_GOODS_SN",
        params
      });
    },
    shareSkuDateRangeFlowNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/saveBatch`,
        name: "SHARE_SKU_DATE_RANGE_FLOW_NEW",
        params
      });
    },
    addFixedShareRule({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/addFixedShareSku`,
        name: "ADD_FIXED_SHARE_SKU",
        params
      });
    },
    queryShareSkuDateRangeFlowNewList({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/list`,
        name: "QUERY_SHARE_SKU_DATE_RANGE_FLOW_NEW_LIST",
        params
      });
    },
    queryAllShareSkuDateRangeFlowNewList({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/list`,
        name: "QUERY_ALL_SHARE_SKU_DATE_RANGE_FLOW_NEW_LIST",
        params
      });
    },
    editShareSkuDateRangeFlowNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/edit`,
        name: "EDIT_SHARE_SKU_DATE_RANGE_FLOW_NEW",
        params
      });
    },
    addOrUpdate({ commit }, params) {
      return post({
        commit,
        url: `/sys/text/addOrUpdate`,
        name: "SYS_TEXT_ADDORUP",
        params
      });
    },
    queryByInfo({ commit }, params) {
      return post({
        commit,
        url: `/sys/text/queryByInfo`,
        name: "QUERY_BY_INFO",
        params
      });
    },
    queryShareMemberOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/share_order_list`,
        name: "QUERY_SHARE_MEMBER_ORDER_LIST",
        params
      });
    },
    queryAllShareMemberOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/share_order_list`,
        name: "QUERY_ALL_SHARE_MEMBER_ORDER_LIST",
        params
      });
    },
    queryShareCommissionFlowList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/queryShareCommissionFlowList`,
        name: "QUERY_SHARE_COMMISSION_FLOW_LIST",
        params
      });
    },
    queryShareCommissionFlowAllList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/queryShareCommissionFlowList`,
        name: "QUERY_SHARE_COMMISSION_FLOW_ALL_LIST",
        params
      });
    },
    queryPersonalStoreState({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "QUERY_PERSONAL_STORE_STATE",
        params
      });
    },
    addPersonalStoreState({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/add`,
        name: "ADD_PERSONAL_STORE_STATE",
        params
      });
    },
    editPersonalStoreState({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/edit`,
        name: "EDIT_PERSONAL_STORE_STATE",
        params
      });
    },
    batchEditRangeFlowNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/batchEdit`,
        name: "BATCH_EDIT_RANGE_FLOW_NEW",
        params
      });
    },
    exportFlowDetailsList({ commit }, params) {
      return post({
        commit,
        url: `/share/agent/exportFlowDetailsList?false`,
        name: "EXPORT_FLOW_DETAILS_LIST",
        params
      });
    },
    queryShareMemberInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/queryShareMemberInfo`,
        name: "QUERY_SHARE_MEMBER_INFO_LIST",
        params
      });
    },
    changeShareMemberDueDate({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/changeShareMemberDueDate`,
        name: "EDIT_SHARE_DUE_DATE",
        params
      });
    },
    queryPartnerPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/shareMemberRelInfo/queryPartnerPageList`,
        name: "QUERY_PARTNER_LIST",
        params
      });
    },
    shareSkuDateRangeExport({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/shareSkuDateRangeExport?false`,
        name: "EXPORT_SKU_DATE_RANGE",
        params
      });
    },
    queryStoreExamineConfigStates({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/queryStoreExamineConfigStates`,
        name: "QUERY_STORE_EXAMINE_STATES",
        params
      });
    },
    shareAgentDistributioRuleMemberDuedayDesc({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=share_agent_distributio_rule_member_dueday_desc`,
        name: "SHARE_AGENT_DISTRIBUTIO_RULE_MEMBER_DUEDAY_DESC",
        params
      });
    },
    shareGroupList({ commit }, params) {
      return post({
        commit,
        url: `/store/share/group/list`,
        name: "SHARE_GROUP_LIST",
        params
      })
    },
    addShareGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/share/group/add`,
        name: "ADD_SHARE_GROUP",
        params
      })
    },
    editShareGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/share/group/edit`,
        name: "EDIT_SHARE_GROUP",
        params
      })
    },
    deleteShareGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/share/group/delete`,
        name: "DELETE_SHARE_GROUP",
        params
      })
    },
    saveMemberShareGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/share/group/member/rel/add`,
        name: "SAVE_MEMBER_SHARE_GROUP",
        params
      })
    },
  }
};

export default distributionCenter;
